import * as React from "react";

import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { Card, List } from "semantic-ui-react";

import { EmployeePartialMatch, MatchFieldTypes } from "../model";

import { Link } from "redux-little-router";

interface PartiallyMatchedEmployeeRecordCardProps {
    referralCustomerId: string;
    referralId: string;
    employeeRecord: EmployeePartialMatch;
    fieldClassNames: Record<string, string>;
    showAdditionalMatchDetails?: boolean;
    hideMoreRoute?: boolean;
}

export const PartiallyMatchedEmployeeRecordCard: React.FunctionComponent<PartiallyMatchedEmployeeRecordCardProps> =
    (props: PartiallyMatchedEmployeeRecordCardProps) => {
        const partialMatchImprovementsEnabled = getFeatureToggles()[FeatureToggleNames.PartialMatchImprovements];

        return (
            <Card key={props.employeeRecord.employeeRecordId}>
                <Card.Content>
                    <Card.Header className="partial-matches-header">
                    Current Employee Record Details
                    </Card.Header>
                    <List>
                        <List.Item>
                            <List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.FirstName]}>
                                First Name
                                </span>
                            </List.Header>
                            <span className={props.fieldClassNames[MatchFieldTypes.FirstName]}>
                                {props.employeeRecord.firstName}&nbsp;
                            </span>
                        </List.Item>
                        <List.Item>
                            <List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.LastName]}>
                                Last Name
                                </span>
                            </List.Header>
                            <span className={props.fieldClassNames[MatchFieldTypes.LastName]}>
                                {props.employeeRecord.lastName}&nbsp;
                            </span>
                        </List.Item>
                        <List.Item>
                            <List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.EmailAddress]}>
                                Email Address
                                </span>
                            </List.Header>
                            <span className={props.fieldClassNames[MatchFieldTypes.EmailAddress]}>
                                {props.employeeRecord.emailAddress}&nbsp;
                            </span>
                        </List.Item>
                        <List.Item>
                            <List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.DateOfBirth]}>
                                Date of Birth
                                </span>
                            </List.Header>
                            <span className={props.fieldClassNames[MatchFieldTypes.DateOfBirth]}>
                                {props.employeeRecord.dateOfBirth && props.employeeRecord.dateOfBirth.format("DD/MM/YYYY")}&nbsp;
                            </span>
                        </List.Item>
                        {partialMatchImprovementsEnabled &&
                            <List.Item>
                                <List.Header>
                                    <span className={props.fieldClassNames[MatchFieldTypes.OrgStructureOneName]}>
                                        Organisation Structure One
                                    </span>
                                </List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.OrgStructureOneName]}>
                                    {props.employeeRecord.orgStructureOneName}&nbsp;
                                </span>
                            </List.Item>
                        }
                        {props.showAdditionalMatchDetails &&
                        <>
                            <List.Item>
                                <List.Header>
                                    <span className={props.fieldClassNames[MatchFieldTypes.MobilePhoneNumber]}>
                                        Mobile Telephone
                                    </span>
                                </List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.MobilePhoneNumber]}>
                                    {props.employeeRecord.mobilePhoneNumber}&nbsp;
                                </span>
                            </List.Item>
                            <List.Item>
                                <List.Header>
                                    <span className={props.fieldClassNames[MatchFieldTypes.JobTitle]}>
                                        Job Role
                                    </span>
                                </List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.JobTitle]}>
                                    {props.employeeRecord.jobTitle}&nbsp;
                                </span>
                            </List.Item>
                        </>
                        }
                        <List.Item>
                            <List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.EmployeeUniqueId]}>
                                Employee Unique ID
                                </span>
                            </List.Header>
                            <span className={props.fieldClassNames[MatchFieldTypes.EmployeeUniqueId]}>
                                {props.employeeRecord.employeeUniqueId}&nbsp;
                            </span>
                        </List.Item>
                        <List.Item>
                            <List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.Postcode]}>
                                Postcode
                                </span>
                            </List.Header>
                            <span className={props.fieldClassNames[MatchFieldTypes.Postcode]}>
                                {props.employeeRecord.postcode}&nbsp;
                            </span>
                        </List.Item>
                        <List.Item>
                            <List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.CustomerName]}>
                                Customer
                                </span>
                            </List.Header>
                            <span className={props.fieldClassNames[MatchFieldTypes.CustomerName]}>
                                {props.employeeRecord.customerName}&nbsp;
                            </span>
                        </List.Item>
                        <List.Item>
                            <List.Header>
                                <span className={props.fieldClassNames[MatchFieldTypes.TerminationDate]}>
                                Termination Date
                                </span>
                            </List.Header>
                            <span className={props.fieldClassNames[MatchFieldTypes.TerminationDate]}>
                                {props.employeeRecord.terminationDate
                                    ? props.employeeRecord.terminationDate
                                    : ""}&nbsp;
                            </span>
                        </List.Item>
                        {!props.hideMoreRoute &&
                        <List.Item>
                            <Link
                                href={`/customers/${props.referralCustomerId}/employeeRecords/${props.employeeRecord.employeeRecordId}`}
                                target="_blank"
                            >
                                More...
                            </Link>
                        </List.Item>
                        }
                    </List>
                </Card.Content>
            </Card>
        );
    };
